import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import DefaultCard from '../../../components/default/DefaultCard';
import { AppContext } from '../../../contexts/AppContext';
import { PurchaseDocumentHistoryDataForm, PurchaseDocumentHistoryFilters } from '../../../app/models/PurchaseDocumentHistory';
import PurchaseDocumentHistoryDataTable from './tables/PurchaseDocumentHistoryDataTable';
import usePurchaseDocumentHistoryService from '../../../app/services/hooks/usePurchaseDocumentHistoryService';

interface Props {
    purchaseDocumentId: number;
    purchaseDocumentHistory: PurchaseDocumentHistoryDataForm[]
    totalRowsHistory: number;
    filterHistory: PurchaseDocumentHistoryFilters;
    setFilterHistory: (filter: PurchaseDocumentHistoryFilters) => void;
    setPurchaseDocumentHistoryTable?: (purchaseDocumentHistory: PurchaseDocumentHistoryDataForm[]) => void;
    reloadPurchaseDocumentHistoryTable: () => void;
    readOnly?: boolean;
}

const PurchaseDocumentHistoryContainer = ({ 
    purchaseDocumentId,
    purchaseDocumentHistory,
    totalRowsHistory,
    filterHistory,
    setFilterHistory,
    setPurchaseDocumentHistoryTable,
    reloadPurchaseDocumentHistoryTable,
    

}: Props) => {

    const { getAllPurchaseDocumentHistoriesByInvoice, fetchingGetPurchaseDocumentHistoriesByInvoice } = usePurchaseDocumentHistoryService();

    return (
        <>
            <DefaultCard>
                <div className="row">
                    <div className="col-12">
                        <PurchaseDocumentHistoryDataTable
                            purchaseDocumentId={purchaseDocumentId}
                            purchaseDocumentHistories={purchaseDocumentHistory}
                            loading={fetchingGetPurchaseDocumentHistoriesByInvoice}
                            totalRows={totalRowsHistory}
                            filter={filterHistory}
                            setFilter={setFilterHistory}
                            callbackSuccess={reloadPurchaseDocumentHistoryTable}
                        />
                    </div>
                </div>
            </DefaultCard>
        </>
    );
};

export default PurchaseDocumentHistoryContainer;
